import { useEffect, useState } from 'react'

const useDeviceDetection = () => {
    const [isMobileiOS, setIsMobileiOS] = useState(false)
    const [isIPad, setIsIPad] = useState(false)
    const [isDesktopSafari, setIsDesktopSafari] = useState(false)
    const [isFirefox, setIsFirefox] = useState(false)
    const [isChrome, setIsChrome] = useState(false)
    const [isEdge, setIsEdge] = useState(false)
    const [isSafari, setIsSafari] = useState(false)
    const [isChromium, setIsChromium] = useState(false)
    const [deviceType, setDeviceType] = useState('desktop')

    useEffect(() => {
        const userAgent = window.navigator.userAgent.toLowerCase()

        // Browser detection
        const isFirefoxDetected = /firefox/i.test(userAgent)
        const isChromeDetected =
            /chrome/i.test(userAgent) &&
            !/edge/i.test(userAgent) &&
            !/edg/i.test(userAgent)
        const isSafariDetected = /^((?!chrome|android).)*safari/i.test(
            userAgent,
        )
        const isEdgeDetected = /edge/i.test(userAgent) || /edg/i.test(userAgent)
        const isChromiumDetected = /chrome|chromium|edg|opera|opr/i.test(
            userAgent,
        )

        // Device detection
        const isIOS = /ipad|iphone|ipod/.test(userAgent) && !window.MSStream
        const isMobile = /mobile|iphone|ipod|ipad/.test(userAgent)
        const isTablet = /ipad|android(?!.*mobile)/i.test(userAgent)
        const isIPadDetected = /ipad/i.test(userAgent)

        // Set browser states
        setIsFirefox(isFirefoxDetected)
        setIsChrome(isChromeDetected)
        setIsEdge(isEdgeDetected)
        setIsSafari(isSafariDetected)
        setIsChromium(isChromiumDetected)

        // Set device states
        setIsMobileiOS(isIOS && isMobile)
        setIsIPad(isIPadDetected)
        setIsDesktopSafari(
            isSafariDetected && /macintosh/.test(userAgent) && !isMobile,
        )

        // Set device type
        if (isTablet) {
            setDeviceType('tablet')
        } else if (isMobile) {
            setDeviceType('mobile')
        } else {
            setDeviceType('desktop')
        }
    }, [])

    return {
        // Browser detection
        isSafari,
        isFirefox,
        isChrome,
        isEdge,
        isChromium,

        // Device detection
        isMobileiOS,
        isIPad,
        isDesktopSafari,
        deviceType,

        // Convenience properties
        isMobile: deviceType === 'mobile',
        isTablet: deviceType === 'tablet',
        isDesktop: deviceType === 'desktop',
    }
}

export default useDeviceDetection
